const BADGES = {
    ADMIN : 'ADMIN',
    MODO : 'MODO',
    CERTIFIED : 'CERTIFIED',
    GOLD : 'GOLD',
    VOISSA_PLUS : 'VOISSA_PLUS', // Voissa Plus (argent)
    NEW_USER : 'NEW_USER'
}

export {
    BADGES
};